import { type Signal } from '@angular/core';

/** The shell's presentation contract, available before the routed chat implementation is downloaded. */
export abstract class RoutedChatLayout {
  public abstract readonly standaloneCompact: Signal<boolean>;
}
